let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kwG70")).then(() => parcelRequire('gGFAO'));